// extracted by mini-css-extract-plugin
module.exports = {"detailInfo":"ServiceInfo_detailInfo__2LbYi"};